import { z } from 'zod';
import { CONTACT_FIELD_KEYS } from '../../constants';
import { questionRefSchema } from './question-data';

const contactLanguageMessages = z.object({
  title: z.string().optional(),
  instruction: z.string().optional(),
});

/** A fixed contact field, referenced by key; reorderable but not removable. */
const contactFieldItemSchema = z.object({
  kind: z.literal('field'),
  key: z.enum(CONTACT_FIELD_KEYS),
});

/**
 * A question interleaved into the contact block's body; addable and removable.
 * Stores only a `{ question_id }` reference — the full question (text, type, options,
 * i18n) is resolved at render time from `config.availableQuestions`, mirroring how
 * standalone question blocks work.
 */
const contactQuestionItemSchema = z.object({
  kind: z.literal('question'),
  question: questionRefSchema,
});

/** The ordered body of the contact block: fixed fields and selected questions. */
export const contactItemSchema = z.discriminatedUnion('kind', [
  contactFieldItemSchema,
  contactQuestionItemSchema,
]);
export type ContactItemInput = z.infer<typeof contactItemSchema>;

export const contactDataSchema = z.object({
  title: z.string().optional(),
  instruction: z.string().optional(),
  i18n: z.object({
    en: contactLanguageMessages,
    es: contactLanguageMessages,
  }),
  /** Ordered fields + questions. Absent on legacy blocks, which fall back to `CONTACT_FIELDS`. */
  items: z.array(contactItemSchema).optional(),
  consent: z.boolean().optional(),
  form_consent_id: z.number().optional(),
});
export type ContactDataInput = z.infer<typeof contactDataSchema>;
